// Min level to show select save popup.

import { DateTime } from 'luxon';
import type { Match2Reward } from '../match2/rewards/match2-rewards.ruleset';

// Players under this level will not see the popup and their save will be automatically overwritten.
export const conflictResolutionMinLevel = 4;

// Minimum timestamp for valid guest states during conflict resolution.
// Guest states with lastLoginAt older than this timestamp are automatically discarded.
// This cutoff was introduced to invalidate states saved during a period when the migration
// system had a bug. The timestamp is set to just before the bug fix was deployed.
export const conflictResolutionMinTimestamp = DateTime.fromISO(
  '2025-12-11T20:00:00',
  {
    zone: 'Asia/Tokyo',
  },
).toMillis();

/**
 * Reward for the guest user that converted to LINE user
 */
export const guestLineLoginReward: Match2Reward = {
  type: 'gems',
  amount: 100,
};
